import React from "react";
import styled from "styled-components";
import {PatronThemeProvider, Button, Box} from "@unibuddy/patron";
import {IconUbGoogle} from "@unibuddy/icons";

const GoogleButtonTheme = {
    Button: {
        colors: {
            googleLight: {
                clearColor: "#1f1f1f",
                bgColor: "white",
                borderColor: "#757775",
                clearHoverBgColor: "#efefef",
            },
            googleDark: {
                clearColor: "#e3e3e3",
                bgColor: "#131314",
                borderColor: "#8e918f",
                outlineColor: "none",
                clearHoverBgColor: "#252526",
            },
        },
    },
};

const AnimatedButton = styled(Button)<{$isLight: boolean}>`
    transition: background-color 0.218s;
    background-color: ${({$isLight}) => ($isLight ? "#ffffff" : "#131314")};
    &:focus,
    &:active {
        background-color: ${({$isLight}) => ($isLight ? "#e6e6e6" : "#303031")};
    }

    &:focus {
        outline-width: 2px;
        outline-offset: 2px;
        outline-color: ${({theme}) => theme.colors.blue600};
    }

    &[disabled] {
        cursor: default;
        background-color: #ffffff61;
        border-color: #1f1f1f1f;
    }
`;

const ButtonContent = styled(Box)`
    letter-spacing: 0.25px;
    > svg {
        flex-shrink: 0;
        margin: 0;
        margin-right: 12px;
    }
    ${AnimatedButton}[disabled] & {
        opacity: 38%;
    }
`;

type GoogleAuthButtonProps = {
    buttonText: string;
    onClick?: () => void;
    variant?: "googleLight" | "googleDark";
};

export function GoogleAuthButton({
    buttonText,
    onClick,
    variant = "googleLight",
}: GoogleAuthButtonProps) {
    return (
        <PatronThemeProvider theme={GoogleButtonTheme}>
            <AnimatedButton
                $isLight={variant === "googleLight"}
                block
                ghost
                color={variant}
                onClick={() => {
                    onClick?.();
                }}
            >
                <ButtonContent display="flex" alignItems="center">
                    <IconUbGoogle width={20} height={20} />
                    {buttonText}
                </ButtonContent>
            </AnimatedButton>
        </PatronThemeProvider>
    );
}
